var map = {
	"./211118_30_Sekundenteaser_ap.mp4": 20,
	"./211118_Jungtiere_ap.mp4": 85,
	"./211123_Wolf_FINAL_ap.mp4": 86,
	"./Teaserbild_A.png": 87,
	"./Teaserbild_B.png": 88,
	"./beverin.jpg": 21,
	"./carnet_down.png": 89,
	"./carnet_down.svg": 90,
	"./carnet_down_hover.png": 91,
	"./carnet_down_hover.svg": 92,
	"./charts_bestand.svg": 22,
	"./charts_risse.svg": 23,
	"./charts_rudel.svg": 24,
	"./header_desk.jpg": 93,
	"./herdenschutz.jpg": 25,
	"./m92.jpg": 26,
	"./nahrung.png": 27,
	"./organigram-01.jpg": 28,
	"./organigram-01_mob.jpg": 29,
	"./playicon.svg": 94,
	"./quotes.jpg": 95,
	"./risse.jpg": 30,
	"./switzerland-01.png": 31,
	"./verhalten.jpg": 96,
	"./verhalten.png": 32,
	"./video.jpg": 97,
	"./welpen.jpg": 98,
	"./wolf_header_1.gif": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;